import { AddEditOrderBreadcrumbSteps } from '../models/add-edit-order-breadcrumb-steps.enum';

export const validationMixins = {
  isAddEditOrderBreadcrumbStep(urlStep: string): urlStep is AddEditOrderBreadcrumbSteps {
    return Object.values(AddEditOrderBreadcrumbSteps).includes(urlStep as AddEditOrderBreadcrumbSteps);
  },
};
